// extracted by mini-css-extract-plugin
var _1 = "assets-js-GalleryPB-components-NoResultsHeader-NoResultsHeader-module__noResultsHeader__YsFHo";
var _2 = "assets-js-GalleryPB-components-NoResultsHeader-NoResultsHeader-module__noResultsHeaderWrapper__QqOxN";
export { _1 as "noResultsHeader", _2 as "noResultsHeaderWrapper" }
